<template>
  <div class="pay-success-wrapper">
    <div class="success-icon"><icon icon-class="cricle-success"></icon></div>
    <h2>支付成功</h2>
    <div class="order-number">订单编号：<span>{{orderNumber}}</span></div>
    <!-- 订单为问诊订单 -->
    <div class="booked-container" v-if="type == 1">
      <div class="order-tip">请在就诊前填写问诊单，帮助医生诊断</div>
      <div class="control-button"><button class="questionnaire-button" @click="editQuestion">填写问诊单</button></div>
      <router-link class="skip" to="/patient">跳过</router-link>
      <div class="edit-tip">稍后到“我的 - 我的病历”中进行填写</div>
    </div>
    <div class="booked-container" v-else-if="type==4">
      <div class="order-tip">预约挂号成功</div>
      <router-link class="skip" to="/patient/order">查看挂号信息</router-link>
      <div class="edit-tip">请到到“我的 - 我的订单”中查看挂号信息</div>
    </div>
    <!-- 订单为处方订单 -->
    <div class="script-container" v-else>
      <div class="order-tip">将会尽快安排寄出，请留意查收</div>
      <div class="control-button"><button class="back-button" @click="back">返回</button></div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .pay-success-wrapper{
    padding-top: 36px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .success-icon{
      margin-bottom: 17px;
      svg{
        font-size: 63px;
        color: @xile;
      }
    }
    h2{
      font-size: 20px;
      line-height: 20px;
      color: @black;
    }
    .order-number{
      margin-top: 16px;
      font-size: 14px;
      line-height: 16px;
      color: #666;
      span{
        font-size: 17px;
        color: @black;
      }
    }
    .booked-container{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .order-tip{
      margin-top: 20px;
      font-size: 14px;
      line-height: 14px;
      color: #666;
      text-align: center;
    }
    .control-button{
      width: 240px;
      margin: 40px auto 0;
      button{
        @button-base();
        width: 100%;
        height: 36px;
      }
    }
    .skip{
      display: inline-block;
      text-align: center;
      margin: 24px auto 0;
      font-size: 12px;
      line-height: 12px;
      color: #666;
    }
    .edit-tip{
      margin-top: 8px;
      font-size: 12px;
      line-height: 12px;
      color: #999;
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        orderNumber: this.$route.query.order_number,
        type: this.$route.query.type,
        questionnaireId: null,
        questionnaireType: null,
      }
    },
    created() {
      console.log(this.$route.query);
      if(this.type == 1) {
        this.$root.post('/getAnswerId', {
          order_id: this.$route.query.order_id
        }).then(data => {
          this.questionnaireId = data.id;
          this.questionnaireType = data.type;
        })
      }
    },
    methods: {
      back() {
        this.$router.go(-1);
      },
      editQuestion() {
        if(this.questionnaireType == 1) {
          this.$router.push({path: '/patient/questionnaire', query: {id: this.questionnaireId}})
        }else {
          this.$router.push({path: '/patient/questionnaire/westen', query: {id: this.questionnaireId}})
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/Order/paySuccess.vue